import {PdsAbstractInputWidget} from './pds-abstract-input-widget';
import {BasicValidationRules} from 'common-utils/interfaces';
import { pdsI18n } from './pds-i18n';
import { pdsValidationRulesEngine } from './pds-validation-rules-engine';
import { pdsValidation } from './pds-validation';

export class PdsDateWidget extends PdsAbstractInputWidget {
  is = 'pds-date-widget';

  //Text Labels
  buttonText: string;

  //Validation Properties
  dataMaxdate: string;
  dataMindate: string;

  //Calendar specific Properties
  dialogValue: Date;
  showDatePickerDialog = false;
  scopeClass: string | null;

  properties = {
    //AbstractInputWidget Properties
    name: String, //We construct the id using the name property
    dataLabelText: String,
    dataShowLabel: {
      type: String,
      value: null
    },
    dataBadgeText: {
      type: String,
      value: '',
      observer: 'setUpBadge'
    },
    dataHelperText: {
      type: String,
      value: null
    },
    dataFieldHelpText: String,
    dataPlaceholderText: String,
    dataTooltipText: String,
    dataUseAlternateColorScheme: {
      type: String,
      value: 'false'
    },
    dataIsreadonly: {
      type: String,
      value: 'false',
      observer: 'setReadonlyText'
    },
    dataIsfieldonly: {
      //This is for adding a class to get rid of the bottom padding.
      type: String,
      value: 'false'
    },
    dataHideUnelevatedBadge: {
      type: String,
      value: 'false',
      observer: 'setUpBadge'
    },
    dataDisableInvalidBadgeElevation: {
      type: String,
      value: 'false',
      observer: 'setUpBadge'
    },
    //Widget specific Validation Properties
    dataIsrequired: {
      type: String,
      value: 'false',
      observer: 'setUpBadge'
    },
    disabled: {
      type: String,
      value: 'false'
    },
    dataMaxdate: String,
    dataMindate: String,
    dataCustomvalidate: String,
    dataActionIcon: String,
    scopeClass: {
      type: String,
      value: null
    }
  };

  generateValidationRules(): void {
    let validationRules: BasicValidationRules = pdsValidationRulesEngine.getBasicValidationRules();

    validationRules.isDate = true;
    validationRules.setProperty('isRequired', this.dataIsrequired, Boolean);
    validationRules.setProperty('maxValue', this.dataMaxdate, Date);
    validationRules.setProperty('minValue', this.dataMindate, Date);

    this.validators = pdsValidationRulesEngine.getValidatorsForRules(validationRules);

    if ('dataCustomvalidate' in this) {
      this.validators.push({
        execute: pdsValidation.getCustomValidate(this.dataCustomvalidate),
        condition: {
          element: this
        }
      });
    }
  }

  /**
   * @param modelValue
   * @param skip
   * @returns returns if the model value was actually set.
   */
  setModelValue(modelValue: Date, skip = false): boolean {
    let ele = this.querySelector('input');
    if (ele != null && modelValue !== ele.modelValue) {
      ele.modelValue = modelValue;
      this.dialogValue = modelValue;
      if (skip !== true) {
        this.setValue(pdsI18n.localizeDate(modelValue), true);
      }
      return true;
    }
    return false;
  }

  setValue(value, skip = false): void {
    if (value == null) {
      value = '';
    }
    let inputEl = this.querySelector('input');
    if (inputEl != null && value !== inputEl.value) {
      inputEl.value = value;
    }
    if (skip !== true) {
      this.setModelValue(pdsI18n.deLocalizeDate(value), true);
    }
  }

  dateChanged(e): void {
    //Although we could directly set the modelValue, setting the value as the user would
    //and then calling inputChange goes through the same path that things go through when the user types in dates which
    //should be more maintanable.
    this.value = pdsI18n.localizeDate(e.target.value);
    this.inputChange();
    this.validateWidget(true);
    this.closeDatePickerDialog();

    this.dispatchInputEvent(this.querySelector('input'));
  }
  /**
   * When the space key is pressed, although we are pressing a key a click event gets fired.
   * The only way to differentiate, truly between a click and a keypress is to check the x/clientX
   * or y/clientY property of the event. if it is 0 then its a key press.
   * https://stackoverflow.com/questions/22151676/how-to-prevent-a-keypress-event-firing-a-click-event-when-focus-is-on-a-butt
   * @param event
   */

  openDatePickerDialog(event: any): void {
    if (event.clientX !== 0 && event.clientY !== 0) {
      // clicked, not key press
      this.showDatePickerDialog = true;
    }
  }

  closeDatePickerDialog(): void {
    this.showDatePickerDialog = false;
  }
}
